<script lang="ts" module>
	import Button from "@components/common/Button.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import { ButtonVariant } from "@components/common/ButtonVariant.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import { Auth } from "@utils/Auth.svelte.js";
	import { AuthChannel } from "@utils/AuthChannel.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import googleLogo from "@core/assets/images/google-logo.svg?raw";
	import { createReactiveBreakpoint } from "@core/utils/createReactiveBreakpoint.js";
	import { createPromiseWithStatus } from "@core/utils/svelte/createPromiseWithStatus.svelte.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import translations from "./SignInWithGoogle.translations.json" with { type: "json" };
</script>

<script lang="ts">
	const isDesktop = createReactiveBreakpoint(">md");
	const translate = getTranslate(translations);

	const { tenant } = getGlobalTemplateProps();
	const signInWithAPopup = createPromiseWithStatus(Auth.initiateGoogleSignIn.bind(Auth, tenant.locale));
</script>

<Button
	type="button"
	variant={ButtonVariant.Outlined}
	size={isDesktop.current ? ButtonSize.Large : ButtonSize.Medium}
	class="justify-between normal-case tracking-normal"
	onclick={async (): Promise<void> => {
		const authChannel = new AuthChannel();

		try {
			await signInWithAPopup.call(authChannel);
		} finally {
			authChannel.close();
		}
	}}
	loading={signInWithAPopup.value.status === "loading"}
>
	<Icon icon={googleLogo} class="size-6" />
	<Formatted text={translate("continueWithGoogle")} />
	<div class="size-6"></div>
</Button>
